import { ExternalLink, Tv } from "lucide-react";

/**
 * Canales de TV financiera en directo (streams oficiales de YouTube).
 * Se reproducen en el navegador del usuario; no pasa vídeo por nuestro servidor.
 * Para añadir/quitar canales basta editar este array (channel ID de YouTube).
 */
const CHANNELS = [
  { name: "Euronews ES", lang: "ES", channelId: "UCyoGb3SMlTlB8CLGVH4c8Rw" },
  { name: "DW Español", lang: "ES", channelId: "UCT4Jg8h03dD0iN3Pb5L0PMA" },
  { name: "Al Jazeera", lang: "EN", channelId: "UCNye-wNBqNL5ZzHSJj3l8Bg" },
  { name: "Yahoo Finance", lang: "EN", channelId: "UCEAZeUIeJs0IjQiqTCdVSIg" },
];

function TVCell({ name, lang, channelId }) {
  // autoplay solo permitido por los navegadores si va silenciado (mute=1):
  // los canales arrancan solos en silencio; un clic en el vídeo activa el audio.
  const embedUrl = `https://www.youtube.com/embed/live_stream?channel=${channelId}&autoplay=1&mute=1&rel=0`;
  const channelUrl = `https://www.youtube.com/channel/${channelId}/live`;
  return (
    <div className="bg-gray-900/40 border border-gray-800 rounded-lg overflow-hidden group">
      <div className="flex items-center justify-between px-2.5 py-1.5 bg-gray-900/60">
        <div className="flex items-center gap-1.5 min-w-0">
          <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse flex-shrink-0" />
          <span className="text-[11px] font-semibold text-gray-200 truncate">{name}</span>
          <span className="text-[9px] text-gray-500 border border-gray-700 rounded px-1">{lang}</span>
        </div>
        <a
          href={channelUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-500 hover:text-cyan-400 transition-colors flex-shrink-0"
          title="Abrir en YouTube"
        >
          <ExternalLink className="w-3 h-3" />
        </a>
      </div>
      <div className="relative aspect-video bg-black">
        <iframe
          src={embedUrl}
          title={name}
          className="absolute inset-0 w-full h-full"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          loading="lazy"
        />
      </div>
    </div>
  );
}

function TVGrid() {
  return (
    <div data-testid="tv-grid">
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-2.5">
        {CHANNELS.map((ch) => (
          <TVCell key={ch.channelId} {...ch} />
        ))}
      </div>
      <p className="text-[10px] text-gray-600 mt-2 flex items-center gap-1">
        <Tv className="w-3 h-3" />
        Emisiones oficiales vía YouTube: arrancan solas en silencio (regla de los navegadores); haz clic en un vídeo para escucharlo. Si un canal no está en directo, usa el icono de enlace.
      </p>
    </div>
  );
}

export default TVGrid;
